module.exports = __webpack_public_path__ + "media/images/icon__predict@3x-0e6e450c6d7de4a17ef8ee249eec09a3.png";